import {
  filter_all,
  filter_last_30_days,
  filter_last_month,
  filter_last_week,
  filter_this_month,
  filter_this_week,
  filter_today,
  filter_yesterday,
} from '../../../../../components/filters/DateRangePicker';

export default {
  filters: {
    [filter_today]: 'Hoje',
    [filter_yesterday]: 'Ontem',
    [filter_this_week]: 'Esta semana',
    [filter_last_week]: 'Semana passada',
    [filter_this_month]: 'Este mês',
    [filter_last_month]: 'Mês passado',
    [filter_last_30_days]: 'Últimos 30 dias',
    [filter_all]: 'Todos',
  },
};
